import { render, staticRenderFns } from "./HostBoxSw.vue?vue&type=template&id=524f5c01&"
import script from "./HostBoxSw.vue?vue&type=script&lang=js&"
export * from "./HostBoxSw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports